// TODO: Double check the colors and define on a better place
// colors here need to be hardcoded due to code mimicing with the backend

const colors = {
  subject: "blue",
  active: "#107F10", // successColor
  sold: "#D90D02", // dangerColor
  pending: "#FFCE45", // warningColor
  other: "#131319", // primaryColor
};

export const getPropertyStatusColor = (type: string) => {
  switch (type) {
    case "subject":
      return colors.subject;
    case "comparable-active":
      return colors.active;
    case "comparable-sold":
      return colors.sold;
    case "comparable-pending":
      return colors.pending;
    default:
      return colors.other;
  }
};
